module.exports = __webpack_public_path__ + "static/media/Hbook-15.31aff2ed.jpg";